/* eslint-disable */
import React from 'react'
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  createStyles,
  WithStyles,
  withStyles,
  Grid,
  TableContainer,
  Paper,
  Table,
  TableCell,
  TableRow,
  TableBody,
  TextField,
  Typography,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  InputAdornment,
} from '@material-ui/core'
import { ValidatorForm } from 'react-material-ui-form-validator'

import { mapSite, mapToSiteApiModel, Site } from 'store/Site'
import { TitleAndSubtitle } from 'components/misc/TitleAndSubtitle'
import { ModelState } from 'store/ModelState'
import { connect } from 'react-redux'
import { AppState } from 'store/AppState'
import { getSiteClient } from 'api/client'
import { Color } from '@material-ui/lab'

import {
  hasSupervisorUserAccessLevel,
  isAdmin,
  isSystemAdmin,
} from 'store/oidc/userManager'
import { MultitenantUserState } from '../../../store/reducers/multitenant'
import { SiteApiModel, SiteOwnerApiModel, SwaggerException } from 'api/apiservice'
import { ChatOutlined, SaveTwoTone } from '@material-ui/icons'

const styles = () =>
  createStyles({
    dialogPaperWidthSm: {
      maxWidth: 'unset',
      minWidth: '80vh',
    },
    assetForm: {
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-evenly',
      alignItems: 'center',
      flexWrap: 'wrap',
    },
  })

interface ComponentState<T> extends ModelState {
  readonly siteUpdating: boolean
  readonly isSiteActive: boolean
  readonly comment: string
  readonly isEdited: boolean
}

interface Props {
  // loadSite(): void
  selectedSite?: Site
  closeSiteStatusDialog(): void
  showSiteUpdateNotification(updateResult?: Color): void
  showSuperIntendent: boolean | undefined
  comment: string
}
interface PropsFromState {
  readonly user: MultitenantUserState
  readonly accessToken?: string
  readonly tenantId: number
}

type AllProps = Props & WithStyles<typeof styles> & PropsFromState

class SiteChangeStatus<TSubState = {}> extends React.Component<
  AllProps,
  ComponentState<TSubState>
> {
  constructor(props: AllProps) {
    super(props)
    this.state = {
      isEdited: false,
      comment: '',
      siteUpdating: false,
      isSiteActive: this.props.selectedSite?.active || false
    }
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  isSystemAdmin = isSystemAdmin(this.props.user.selectedTenant?.roles)
  isAdmin = isAdmin(this.props.user.selectedTenant?.roles)
  validRole = hasSupervisorUserAccessLevel(
    this.props.user.selectedTenant?.roles
  )

  superintendent: string | undefined
  foreman: string | undefined
  pumper: string | undefined

  site = this.props.selectedSite!
  siteAPI = getSiteClient(
    this.props.accessToken!,
    this.props.tenantId.toString(),
    this.props.user.email
  )

  formRef = React.createRef<ValidatorForm>()
  private handleInputChange(value, id) {
    switch (id) {
      case 'comment':
        if (value !== null) {
          let sanitizedValue = value.replace(/\r?\n|\r/g, ' ').trim();

          if (sanitizedValue.length > 1024) {
            sanitizedValue = sanitizedValue.substring(0, 1024);
          }

          this.setState({
            comment: sanitizedValue,
            isEdited: sanitizedValue.length > 0 && sanitizedValue.length <= 1024,
          });
        } else {
          this.setState({
            comment: '',
            isEdited: false,
          });
        }
        break;
    }
  }

  private updateSite() {
    try {
      this.setState({ siteUpdating: true });
      let siteApiModel = mapToSiteApiModel(this.props.selectedSite!);
      siteApiModel.active = !siteApiModel.active;
      siteApiModel.comment = this.state.comment;

      this.siteAPI.updateSite(siteApiModel).then((result) => {
        this.props.showSiteUpdateNotification('success');
      }).catch((error) => {
        this.props.showSiteUpdateNotification('error');
        console.error(error);
      });

    } catch (error) {
      this.setState({ siteUpdating: false });
      this.props.showSiteUpdateNotification('error');
      console.error(error);
    }
  }

  handleSubmit() {
    this.beginUpdate()
  }

  handleConfirmation() {
    this.setState({
      siteUpdating: true,
    })
    this.beginUpdate()
  }

  private beginUpdate() {
    this.updateSite()
  }

  public render() {
    const { classes, closeSiteStatusDialog } = this.props;
    const { isSiteActive, siteUpdating } = this.state;
    const newStatus = isSiteActive ? 'Inactive' : 'Active';

    return (
      <Dialog
        disableEscapeKeyDown={true}
        open={true}
        classes={{ paperWidthSm: classes.dialogPaperWidthSm }}
      >
        <DialogContent dividers={true}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography variant="h6" color="primary">
                Confirm Site Status Change
              </Typography>
              <Typography variant="subtitle1" style={{ marginTop: '16px' }}>
                Are you sure you want to change the status of site <strong>{this.site.name}</strong> to <strong>{newStatus}</strong>?
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <TextField
                label="Add Notes (max 1024 characters)"
                placeholder="Type your notes here..."
                multiline
                rows={4}
                variant="outlined"
                fullWidth
                onChange={(e) =>
                  this.handleInputChange(e.target.value, 'comment')
                }
                inputProps={{ maxLength: 1024 }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <ChatOutlined color="primary" />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button
            disabled={siteUpdating}
            onClick={closeSiteStatusDialog}
            color="primary"
          >
            Cancel
          </Button>
          {this.validRole && (
            <Button
              disabled={
                !this.state.isEdited ||
                this.state.siteUpdating
              }
              variant="contained"
              color="primary"
              startIcon={<SaveTwoTone />}
              style={{ whiteSpace: 'nowrap' }}
              onClick={() => {
                this.setState({ isEdited: true }, this.handleSubmit);
              }}
            >
              {siteUpdating ? 'Updating...' : `Set to ${newStatus}`}
            </Button>
          )}
        </DialogActions>
      </Dialog>
    );
  }



}

const mapPropsFromState = ({
  oidc: { user },
  multitenantUser,
}: AppState): PropsFromState => ({
  accessToken: multitenantUser.accessToken,
  tenantId: multitenantUser.tenants?.find((t) => t.selected)?.id || 0,
  user: multitenantUser,
})

export default connect(mapPropsFromState)(withStyles(styles)(SiteChangeStatus))
